import { Schema } from "effect";
import type { ImmutableTreeExecutionError, HostedTestArtifactError } from "./source.ts";

export const StationHttpError = /* @__PURE__ */ (() => {
  class StationHttpError extends Schema.TaggedError<StationHttpError>()("StationHttpError", {
    status: Schema.Literals([400, 404, 405, 409]), message: Schema.String,
    currentUpdatedAt: Schema.optionalKey(Schema.NullOr(Schema.Number))
  }) {}
  return StationHttpError;
})();
export type StationHttpError = InstanceType<typeof StationHttpError>;
export const StationStorageError = /* @__PURE__ */ (() => {
  class StationStorageError extends Schema.TaggedError<StationStorageError>()("StationStorageError", { status: Schema.tag(500), message: Schema.String }) {}
  return StationStorageError;
})();
export type StationStorageError = InstanceType<typeof StationStorageError>;
export type StationStorageFailure = StationStorageError | ImmutableTreeExecutionError | HostedTestArtifactError;
export type StationHttpFailure = StationHttpError | StationStorageFailure;
export const stationInvalid = (message: string) => new StationHttpError({ status: 400, message });
export const stationMissing = (message = "Not found.") => new StationHttpError({ status: 404, message });
export const stationMethod = () => new StationHttpError({ status: 405, message: "Method not allowed." });
export const stationConflict = (currentUpdatedAt: number | null) => new StationHttpError({ status: 409, message: "Workerstation changed since it was read.", currentUpdatedAt });
export const stationUnavailable = () => new StationStorageError({ message: "Station storage is unavailable." });
